import React from 'react'
import { withIcon } from '../../withIcon'

function SortTilesAscIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M5.625 5.625V9.375H9.375V5.625H5.625ZM4.375 5.5C4.375 4.87868 4.87868 4.375 5.5 4.375H9.5C10.1213 4.375 10.625 4.87868 10.625 5.5V9.5C10.625 10.1213 10.1213 10.625 9.5 10.625H5.5C4.87868 10.625 4.375 10.1213 4.375 9.5V5.5ZM16.5581 5.55806C16.8021 5.31398 17.1979 5.31398 17.4419 5.55806L20.4419 8.55806C20.686 8.80214 20.686 9.19786 20.4419 9.44194C20.1979 9.68602 19.8021 9.68602 19.5581 9.44194L17.625 7.50888V18C17.625 18.3452 17.3452 18.625 17 18.625C16.6548 18.625 16.375 18.3452 16.375 18V7.50888L14.4419 9.44194C14.1979 9.68602 13.8021 9.68602 13.5581 9.44194C13.314 9.19786 13.314 8.80214 13.5581 8.55806L16.5581 5.55806ZM5.625 14.625V18.375H9.375V14.625H5.625ZM4.375 14.5C4.375 13.8787 4.87868 13.375 5.5 13.375H9.5C10.1213 13.375 10.625 13.8787 10.625 14.5V18.5C10.625 19.1213 10.1213 19.625 9.5 19.625H5.5C4.87868 19.625 4.375 19.1213 4.375 18.5V14.5Z" fill={color}/>
    </svg>
  )
}

export default withIcon(SortTilesAscIcon)
